import { render } from "./index.vue?vue&type=template&id=038d276d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=038d276d&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=038d276d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038d276d"]])

export default __exports__